/* Copyright (c) 2025 Xperi. All Rights Reserved.  */

import { MayAlsoLikeItems } from 'client-code/feeditems-service';

import { FeedItemsServiceRepositoryImpl } from '../impls/FeedItemsServiceRepositoryImpl';
import { IFeedItemsService, IFeedItemsServiceRepository } from '../interfaces';
import { TServicesParams } from '../types';

export class FeedItemsService implements IFeedItemsService {
    private feedItemsServiceRepository: IFeedItemsServiceRepository;

    public constructor(params: TServicesParams) {
        this.feedItemsServiceRepository = new FeedItemsServiceRepositoryImpl(params);
    }

    private static cache: Map<string, MayAlsoLikeItems> = new Map();

    /**
     * Clears the entire cache for all May Also Like functions
     */
    public static clearCache(): void {
        FeedItemsService.cache.clear();
    }

    public async fetchMayAlsoLikeContent(
        contentId: string,
        offset?: number,
        count?: number,
        includeAdult?: boolean,
        includeIpVod?: boolean,
        includeSportsPass?: boolean,
        providerPartnerId?: string,
    ): Promise<MayAlsoLikeItems> {
        return this.feedItemsServiceRepository.contentMayAlsoLikeGet(
            contentId,
            offset,
            count,
            includeAdult,
            includeIpVod,
            includeSportsPass,
            providerPartnerId,
        );
    }

    public async fetchMayAlsoLikeCollection(
        applicationFeatureArea: string,
        collectionId: string,
        offset?: number,
        count?: number,
        includeAdult?: boolean,
        includeIpVod?: boolean,
        includeSportsPass?: boolean,
        providerPartnerId?: string,
        isSeries?: boolean,
    ): Promise<MayAlsoLikeItems> {
        const cacheKey = `collection-${applicationFeatureArea}-${collectionId}`;
        if (FeedItemsService.cache.has(cacheKey)) {
            return FeedItemsService.cache.get(cacheKey)!;
        }
        const mayAlsoLikeData = await this.feedItemsServiceRepository.collectionMayAlsoLikeGet(
            collectionId,
            offset,
            count,
            includeAdult,
            includeIpVod,
            includeSportsPass,
            providerPartnerId,
            isSeries,
        );
        FeedItemsService.cache.set(cacheKey, mayAlsoLikeData);
        return mayAlsoLikeData;
    }
}
